import { useState } from "react";
import AppShell from "../components/layout/AppShell";
import OnboardingTour from "../components/onboarding/OnboardingTour";
import GestorDashboard from "../components/dashboard/GestorDashboard";
import CorretorDashboard from "../components/dashboard/CorretorDashboard";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";

export default function DashboardPage() {
  var auth = useAuth();
  var user = auth.user;
  var isAdmin = user?.role === "admin";
  var isTeamLeader = user?.role === "team_leader";
  var showOnboardingState = useState(function() {
    if (!isAdmin && !isTeamLeader && !user?.onboarding_completed) {
      return !localStorage.getItem("methos_onboarding_completed");
    }
    return false;
  });
  var showOnboarding = showOnboardingState[0];
  var setShowOnboarding = showOnboardingState[1];

  async function handleOnboardingComplete() {
    setShowOnboarding(false);
    localStorage.setItem("methos_onboarding_completed", "true");
    try { await api.put("/users/me/onboarding"); } catch(e) {}
  }

  return (
    <AppShell activePage="dashboard" title="Dashboard">
      {function({ viewMode, handleViewChange, isAdmin: isAdm }) {
        var badgeColor = viewMode === "gestor" ? "bg-[#3B82F6]/10 text-[#3B82F6]" : "bg-[#F26A4B]/10 text-[#F26A4B]";
        var badgeLabel = viewMode === "gestor" ? "Visão Gestor" : "Visão Corretor";
        return (
          <div data-testid="dashboard-page">
            {showOnboarding && <OnboardingTour onComplete={handleOnboardingComplete} />}
            {(viewMode === "gestor" || isTeamLeader) ? <GestorDashboard /> : <CorretorDashboard />}
          </div>
        );
      }}
    </AppShell>
  );
}
